import type React from "react";
import { useWorkspaceAdmin } from "@/hooks/use-workspace-admin";
import { WorkspaceOverviewPage } from "@/pages/workspace-overview";

// A Workspace Admin's equivalent of the portfolio performance overview (UNB-1953),
// scoped to every brand owned by the workspace rather than just the brands the
// user was individually added to. Access itself is gated by `WorkspaceLayout`
// (UNB-2694) — this only mounts once that's confirmed.
export const WorkspaceOverview: React.FC = () => {
  const { workspace } = useWorkspaceAdmin();
  if (!workspace) return null;

  return <WorkspaceOverviewPage merchants={workspace.merchants} workspaceId={workspace.id} />;
};
